import { Download, Search } from 'lucide-react'
import { isConnectionOwned } from '@/components/OwnedChip'
import { FilterDropdown } from '@/components/ui/filter-dropdown'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { enrolmentStatuses, type Enrolment } from './enrolment'
import type { RosterState } from './roster-columns'

export function RosterToolbar({
  state,
  update,
  rows,
  exportPath,
  searchLabel = 'Search people',
}: {
  state: RosterState
  update: (patch: Partial<RosterState>) => void
  rows: Enrolment[]
  exportPath: string
  searchLabel?: string
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative w-full max-w-xs">
        <Search
          className="pointer-events-none absolute left-2.5 top-1/2 size-3.5 -translate-y-1/2 text-muted-foreground"
          aria-hidden="true"
        />
        <Input
          aria-label={searchLabel}
          className="pl-8"
          placeholder={`${searchLabel}…`}
          value={state.search}
          onChange={(event) => update({ search: event.target.value })}
        />
      </div>
      <FilterDropdown
        label="Status"
        emptyLabel="Status"
        options={Object.entries(enrolmentStatuses).map(([value, label]) => ({ value, label }))}
        selected={new Set(state.status.split(',').filter(Boolean))}
        onChange={(values) => update({ status: [...values].join(',') })}
      />
      <FilterDropdown
        label="Owner"
        emptyLabel="Owner"
        options={ownerOptions(rows)}
        selected={new Set(state.owner ? [state.owner] : [])}
        onChange={(values) => update({ owner: [...values].at(-1) ?? '' })}
      />
      <Button asChild variant="outline" className="ml-auto">
        <a href={`${exportPath}?${new URLSearchParams({ ...state })}`}>
          <Download className="mr-2 size-4" aria-hidden="true" />
          Download CSV
        </a>
      </Button>
    </div>
  )
}

function ownerOptions(rows: Enrolment[]) {
  const owners = new Map([['bright_huddle', 'Bright Huddle']])
  for (const row of rows) {
    if (isConnectionOwned(row.owner)) {
      const owner = row.owner.connection!
      owners.set(String(owner.id), owner.display_name)
    }
  }
  return [...owners].map(([value, label]) => ({ value, label }))
}
